import routerOptions0 from "/app/node_modules/.pnpm/nuxt@4.2.2_@parcel+watcher@2.5.1_@types+node@24.10.1_@vue+compiler-sfc@3.5.26_better-sq_0ee4151e24210ad74a1f5186a42a7e96/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}